import { Route, Routes, Navigate } from "react-router-dom";
import {
  SERVER_ROUTE
} from "../Constants";
import defineConfig from "../../package.json";
import { AmbientInfo } from "../components/AmbientInfo";
import { AppTrafficTickets } from "../app/trafficcTickets/AppTrafficTickets";

export const AppRoute = () => {

  return (
    <div className="m-0 p-0  bg-skin-mainBG">
      {import.meta.env.MODE !== "production" && <AmbientInfo />}
      <Routes>
            <Route
              path={`${defineConfig.homepage}*`}
              // element={<HomeTest />}
              element={<AppTrafficTickets />}
            />
            <Route
              path={`${defineConfig.homepage}*`}
              element={<Navigate to={`${SERVER_ROUTE}`} />}
            />
      </Routes>
    </div>
  );
};
